import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { Store } from '@ngrx/store';
import { Actions, ofType } from '@ngrx/effects';
import { EStepActions, SetStep } from '../../../shared/store/actions/step.actions';
import { AccountInformationInterface } from '../../models/account-information.interface';
import { AccountBillingAddressInterface } from '../../models/account-billing-address.interface';
import { AccountShippingAddressInterface } from '../../models/account-shipping-address.interface';
import { AccountBankInformationInterface } from '../../models/account-bank-information.interface';
import { AccountDocumentsInterface } from '../../models/account-documents.interface';
import { CustomerService } from '../../../account/services/customer.service';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { AlertMessageInterface } from '../../../shared/models/alert-message.interface';
import { GetAlertMessage } from '../../../shared/store/actions/alert-message.actions';
import { GetCustomer } from '../../../account/store/actions/customer.actions';
import { FileService } from '../../../shared/services/file.service';

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.css'],
  standalone: false
})
export class MyAccountComponent implements OnInit {

  steps: Array<{step: number, label: string}> =  [
    {step: 1, label: 'Mes informations'},
    {step: 2, label: 'Adresse de facturation / livraison'},
    {step: 3, label: 'Mes documents'},
    {step: 4, label: 'Mes coordonnées bancaires (facultatif)'},
    //{step: 5, label: 'Confirmation'},
  ];
  currentStep: number;
  brand = environment.data.brand;
  accountInformation: AccountInformationInterface;
  accountBillingAddress: AccountBillingAddressInterface;
  accountShippingAddress: AccountShippingAddressInterface;
  accountBankInformation: AccountBankInformationInterface;
  accountDocuments: AccountDocumentsInterface;
  constructor(
      private store: Store<any>,
      private actions$: Actions,
      private fileService: FileService,
      private customerService: CustomerService,
  ) { }

  ngOnInit() {
    this.store.dispatch(new GetCustomer());
    this.currentStep = 1;
    this.actions$.pipe(ofType(EStepActions.SetStep)).subscribe((result: SetStep) => {
      this.currentStep = result.step;
      window.scrollTo(0, 0);
    });
    if (environment.data.brand === 'lacarte') {
      setInterval(function() {
        const cus = this.customerStorageService.getCustomer();
        if (
            cus !== null &&
            [null, ''].indexOf(cus.email) === -1 &&
            [null, ''].indexOf(cus.lastName) === -1 &&
            [null, ''].indexOf(cus.firstName) === -1
        ) {
          setTimeout(
              // tslint:disable-next-line:only-arrow-functions
              function() {
                window.location.reload();
              }.bind(this),
              1000
          );
          this.router.navigate(['/lignes']);
        }
      }.bind(this), 500);
    }
  }

  getCurrentStepLabel() {
    return this.steps.find(myStep => myStep.step === this.currentStep).label;
  }

  setStep(step: number) {
    if (step <= this.currentStep) {
      this.store.dispatch(new SetStep(step));
    }
  }

  setAccountInformation(data: any) {
    this.accountInformation = data;
    this.currentStep = 2;
  }

  setAccountAddress(data: any) {
    this.accountBillingAddress = data.billingAddress;
    this.accountShippingAddress = data.shippingAddress;
    this.currentStep = 3;
  }

  setAccountBankInformation(data: any) {
    this.accountBankInformation = data;
    this.setAccountConfirmation({code: 'code_test'});
  }

  setAccountDocuments(data: any) {
    this.accountDocuments = data;
    //this.store.dispatch(new SetStep(5));
    this.setAccountConfirmation({code: 'without_iban'});
    this.currentStep = 4;
  }

  setAccountConfirmation(data: any) {
    const customerObj = {
      code: data.code,
      civility: this.accountInformation.civility,
      lastName: this.accountInformation.lastName,
      firstName: this.accountInformation.firstName,
      email: this.accountInformation.email,
      birthDate: this.accountInformation.birthDate,
      department: Number(this.accountInformation.birthDepartment),
      phoneNumber: this.accountInformation.phoneNumber,
      acceptPromoPassAlgerie: this.accountInformation.acceptPromo,
      street: this.accountBillingAddress.address,
      zipCode: this.accountBillingAddress.zipCode,
      city: this.accountBillingAddress.city,
      addressComplement: this.accountBillingAddress.addressComplement,
      iban: this.accountBankInformation ? this.accountBankInformation.iban : null,
      bic: this.accountBankInformation ? this.accountBankInformation.bic : null,
      shippingAddressCivility: this.accountShippingAddress.shippingAddressCivility,
      shippingAddressLastName: this.accountShippingAddress.shippingAddressLastName,
      shippingAddressFirstName: this.accountShippingAddress.shippingAddressFirstName,
      shippingAddressStreet: this.accountShippingAddress.address,
      shippingAddressZipCode: this.accountShippingAddress.zipCode,
      shippingAddressCity: this.accountShippingAddress.city,
      shippingAddressAddressComplement: this.accountShippingAddress.addressComplement,
      acceptCgv: this.accountDocuments.acceptCgv,
      acceptActuality: this.accountDocuments.acceptActuality
    };
    if (data.code === 'code_test') {
      this.updateFullInformation(customerObj);
    } else {
      this.fileService.create(this.accountDocuments.identityFrontFile, 'pièce d\'identité - recto', environment.data.identityFrontFileTypeSlug, environment.data.customerFilesBucketSlug).subscribe(
          responseIdentityFrontFile => {
            this.fileService.create(this.accountDocuments.identityBackFile, 'pièce d\'identité - verso', environment.data.identityBackFileTypeSlug, environment.data.customerFilesBucketSlug).subscribe(
                responseIdentityBackFile => {
                  if (this.accountDocuments.selfieCapture) {
                    this.fileService.create(this.accountDocuments.selfieCapture, 'selfie', environment.data.selfieWithIdentityFileTypeSlug, environment.data.customerFilesBucketSlug).subscribe(
                        responseSelfie => {
                          this.updateFullInformation(customerObj);
                        }, error => {
                          const alertMessage = { message: ConstsHelper.ERROR_OCCURRED_MESSAGE, code: 400 } as AlertMessageInterface;
                          this.store.dispatch(new GetAlertMessage(alertMessage));
                        }
                    );
                  } else {
                    this.updateFullInformation(customerObj);
                  }
                }, error => {
                  const alertMessage = { message: ConstsHelper.ERROR_OCCURRED_MESSAGE, code: 400 } as AlertMessageInterface;
                  this.store.dispatch(new GetAlertMessage(alertMessage));
                }
            );
          }, error => {
            const alertMessage = { message: ConstsHelper.ERROR_OCCURRED_MESSAGE, code: 400 } as AlertMessageInterface;
            this.store.dispatch(new GetAlertMessage(alertMessage));
          }
      );
    }
  }

  private updateFullInformation(customerObj: any) {
    this.customerService.updateFullInformation(customerObj).subscribe(
        response => {
          if (customerObj.code === 'code_test') {
            this.store.dispatch(new GetCustomer());
          }
        }, error => {
          const alertMessage = { message: ConstsHelper.ERROR_OCCURRED_MESSAGE, code: 400 } as AlertMessageInterface;
          if (error.error.error_message && error.error.error_message.includes('invalid_code')) {
            alertMessage.message = ConstsHelper.ERROR_MESSAGE_MFA_INVALID_CODE;
          } else if (error.error.error_message && error.error.error_message.includes('blocked')) {
            alertMessage.message = ConstsHelper.ERROR_MESSAGE_MFA_BLOCKED;
          }
          this.store.dispatch(new GetAlertMessage(alertMessage));
        }
    );
  }
}
